export const IMG = {
  PHONES: 'img/category-phones.png',
  TABLETS: 'img/category-tablets.png',
  ACCESSORIES: 'img/category-accessories.png',
};
